;(function () {
  document.addEventListener('DOMContentLoaded', function () {
    document.querySelectorAll('.patrol-video').forEach(function (videoContainer) {
      function waitForElm(selector) {
        return new Promise(resolve => {
          if (videoContainer.querySelector(selector)) {
            return resolve(videoContainer.querySelector(selector))
          }

          const observer = new MutationObserver(mutations => {
            if (videoContainer.querySelector(selector)) {
              observer.disconnect()
              resolve(videoContainer.querySelector(selector))
            }
          })

          observer.observe(document.body, {
            childList: true,
            subtree: true,
          })
        })
      }

      function init() {
        const video = videoContainer.querySelector('video:not(.patrol-loaded)')

        if (video) {
          video.classList.add('patrol-loaded')

          const playPauseBtn = videoContainer.querySelector('.patrol-video__button')
          const playIcon = videoContainer.querySelector('.patrol-video__icon-play')
          const pauseIcon = videoContainer.querySelector('.patrol-video__icon-pause')

          playPauseBtn.addEventListener('click', function (e) {
            e.preventDefault()

            if (video.paused === true) {
              video.play()
            } else {
              video.pause()
            }
          })

          video.addEventListener('play', function () {
            video.setAttribute('data-state', 'play')
            video.setAttribute('data-state-reload', 'false')

            videoContainer.setAttribute('data-state', 'play')

            playIcon.setAttribute('aria-hidden', 'true')
            pauseIcon.setAttribute('aria-hidden', 'false')

            playPauseBtn.setAttribute('aria-label', 'Pause video')
            playPauseBtn.setAttribute('aria-pressed', 'false')
            playPauseBtn.setAttribute('data-button-state', 'play')
            playPauseBtn.setAttribute('data-button-state-reload', 'false')

            document.dispatchEvent(new CustomEvent('patrol:video-play'))
          })

          video.addEventListener('pause', function () {
            video.setAttribute('data-state', 'pause')

            videoContainer.setAttribute('data-state', 'pause')

            playIcon.setAttribute('aria-hidden', 'false')
            pauseIcon.setAttribute('aria-hidden', 'true')

            playPauseBtn.setAttribute('aria-label', 'Play video')
            playPauseBtn.setAttribute('aria-pressed', 'true')
            playPauseBtn.setAttribute('data-button-state', 'pause')

            document.dispatchEvent(new CustomEvent('patrol:video-pause'))
          })

          video.addEventListener('ended', function () {
            video.setAttribute('data-state', 'pause')
            video.setAttribute('data-state-reload', 'true')

            playPauseBtn.setAttribute('aria-pressed', 'true')
            playPauseBtn.setAttribute('data-button-state', 'pause')
            playPauseBtn.setAttribute('data-button-state-reload', 'true')
          })
        }
      }

      waitForElm('video').then(init)
    })
  })
})()
